import React from 'react';
import { Button } from 'antd';
import { Link } from 'react-router-dom';
import { useAuth } from '../../auth/hooks/useAuth';
import MarketingBrand from './MarketingBrand';
import ThemeToggle from '../../../components/ThemeToggle';
import { appPath } from '../../../routes/paths';
import { scrollToSection } from '../utils/scrollToSection';

const NAV_LINKS = [
  { id: 'features', label: 'Features' },
  { id: 'partnership', label: 'Why us' },
  { id: 'commitments', label: 'Commitments' },
  { id: 'pricing', label: 'Pricing' },
] as const;

const MarketingHeader: React.FC = () => {
  const { isAuthenticated } = useAuth();

  return (
    <header className="cp-marketing-header cp-landing-header">
      <MarketingBrand />
      <nav className="cp-marketing-header__nav" aria-label="Primary">
        {NAV_LINKS.map((link) => (
          <button
            key={link.id}
            type="button"
            className="cp-landing-nav-btn"
            onClick={() => scrollToSection(link.id)}
          >
            {link.label}
          </button>
        ))}
      </nav>
      <div className="cp-marketing-header__actions">
        <ThemeToggle />
        {isAuthenticated ? (
          <Link to={appPath()}>
            <Button type="primary">Open app</Button>
          </Link>
        ) : (
          <>
            <Link to="/login">
              <Button type="text" className="cp-landing-header-signin">
                Sign in
              </Button>
            </Link>
            <Link to="/signup">
              <Button type="primary">Get started</Button>
            </Link>
          </>
        )}
      </div>
    </header>
  );
};

export default MarketingHeader;
